import * as React from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import TestHome from './testHome.jsx';
import TestNotify from './testNotify.jsx';

import TestCoolNumberInput from './testCoolNumberInput.jsx';
import TestCoolTextInputV4 from './testCoolTextInputV4.jsx';

import TestDropdown from './testDropdown.jsx';
import TestTextInput from './testTextInput.jsx';
import TestATextInput from './testATextInput.jsx';
import TestATextInputV4 from './testATextInputV4.jsx';
import TestI18N from './testI18N.jsx';
import TestData from "./testData.jsx"
import TestReactSelect from './testReactSelect.jsx';
import TestASelect from './testASelect.jsx';
import TestModalV4 from './testModalV4.jsx'
import TestConfirmModalOkCancelV4 from './TestConfirmModalOkCancelV4.jsx'

class TestMasterPage extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[TestMasterPage.jsx] ";
    }

    componentWillMount() {
        console.log(this.componentName + 'componentWillMount');
    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');
    }

    componentWillUnmount() {
        console.log(this.componentName + 'componentWillUnmount');
    }

    render() {
        console.log(this.componentName + 'render ' + this.props.location.pathname);
        return (
            <div className="row">

                <div className="col-sm-3 bg-light" >
                    <ul className="nav flex-column">
                        <li className="nav-item">
                            <a className="nav-link" href="#/home"><i className="fa fa-home fa-fw" />HOME</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#/test/notify">Notify</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#/test/textInput">Input text</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#/test/testATextInput">ATextInput</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#/test/ATextInputV4">ATextInputV4 </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#/test/coolTextInputV4">CoolTextInputV4 </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#/test/coolNumberInput">Cool number input</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#/test/dropdown">Dropdown</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#/test/testI18N">I18N </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#/test/testData">Test Data</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#/test/testReactSelect">React Select</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#/test/testASelect">Test ASelect</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#/test/testModalV4">Test ModalV4</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#/test/confirmModalOkCancelV4">Test Confirm ModalV4</a>
                        </li>


                    </ul>
                </div>

                <div className="col-sm-9">
                    <Switch>
                        <Redirect exact="true" from="/test" to="/test/home" />
                        <Route path="/test/home" component={TestHome} />
                        <Route path="/test/notify" component={TestNotify} />
                        <Route path="/test/textInput" component={TestTextInput} />
                        <Route path="/test/coolNumberInput" component={TestCoolNumberInput} />
                        <Route path="/test/dropdown" component={TestDropdown} />
                        <Route path="/test/testATextInput" component={TestATextInput} />
                        <Route path="/test/ATextInputV4" component={TestATextInputV4} />
                        <Route path="/test/testI18N" component={TestI18N} />
                        <Route path="/test/testReactSelect" component={TestReactSelect} />
                        <Route path="/test/testASelect" component={TestASelect} />
                        <Route path="/test/coolTextInputV4" component={TestCoolTextInputV4} />
                        <Route path="/test/testModalV4" component={TestModalV4} />
                        <Route path="/test/confirmModalOkCancelV4" component={TestConfirmModalOkCancelV4} />
                        <Route path="/test/testData" component={TestData} />
                    </Switch>
                </div>

            </div>
        );
    }
};

export default TestMasterPage;